/**
 * BillingAccountAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ClientResourceMapping = 0 | 1;

export const ClientResourceMapping = {
    NUMBER_0: 0 as ClientResourceMapping,
    NUMBER_1: 1 as ClientResourceMapping
};